const initialState = {
    data: [],
  };
  
  const glosowaniePytaniaReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GLOSOWANIE_PYTANIA':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default glosowaniePytaniaReducer;